var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFo = function SvgIconFo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "m23.478 12 .42-1.565a12 12 0 0 0-.311-1.565h-12.63V.046a12 12 0 0 0-1.566.24l-2.087 1.28-1.043-.106q-.826.45-1.566 1.02v6.39H.413q-.207.764-.311 1.565L.522 12l-.42 1.565q.105.801.311 1.565h4.282v6.39q.741.57 1.566 1.02l1.565-.105 1.565 1.28q.766.169 1.565.24V15.13h12.63q.207-.765.312-1.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.898 10.435H9.391V.285C8.282.531 7.231.93 6.261 1.46v8.976H.1a12.1 12.1 0 0 0 0 3.13h6.16v8.976c.97.53 2.021.928 3.13 1.174v-10.15h14.507a12.1 12.1 0 0 0 0-3.13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconFo;